import React from "react";
import { Table, Pagination, CircularProgress } from "@ann/web-components";
import Icon from "../../../../../../../../../elements/icon/Icon";
import { 
  TableWrapper, 
  TableContainer, 
  PaginationWrapper, 
  LoadingContainer, 
  NoDataWrapper, 
  NoDataTitle, 
  NoDataDescription 
} from "./FactsTableSection.styled";

const FactsTableSection = ({
  tableData,
  headers,
  currentPage,
  itemsPerPage,
  onItemsPerPageChange,
  onPageChange,
  totalItems,
  totalPages,
  loading,
}) => {
  const showEmptyState = !loading && tableData.length === 0;

  return (
    <TableWrapper>
      <TableContainer>
        {loading ? (
          <LoadingContainer>
            <CircularProgress size="xl" />
          </LoadingContainer>
        ) : showEmptyState ? (
          <NoDataWrapper>
            <Icon name="noDataAvailable" width="201px" height="195px" />
            <NoDataTitle>No facts yet</NoDataTitle>
            <NoDataDescription>
              No facts found.
            </NoDataDescription>
          </NoDataWrapper>
        ) : (
          <Table
            data={tableData}
            headers={headers}
            mode="table"
            showActions={false}
            selectable={true}
            onDeselectAll={() => {}}
            onSelectionChange={() => {}}
          />
        )}
      </TableContainer>
      {!showEmptyState && (
        <PaginationWrapper>
          <Pagination
            currentPage={currentPage}
            itemsPerPage={itemsPerPage}
            onItemsPerPageChange={onItemsPerPageChange}
            onPageChange={onPageChange}
            totalItems={totalItems}
            totalPages={totalPages}
            disabled={loading}
          />
        </PaginationWrapper>
      )}
    </TableWrapper>
  );
};

export default FactsTableSection;

